import './index.css';

import axios from 'axios';
import 'reflect-metadata';

import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { installLegalAgreementInterceptor } from './api/legalAgreementGate';
import reportWebVitals from './reportWebVitals';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL || '';
installLegalAgreementInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
